export default __webpack_public_path__ + "static/media/globeLogo.a6bb5fe5.svg";